import React, { Component } from "react";
import { getClientLanding } from '../utils/request';
import { withRouter } from "react-router";

export class Testimonial extends Component {
    constructor(props) {
        super(props);

        this.state = {
            testi : [],
        };
    }

    componentDidMount() {
        getClientLanding().then((res)=>{
            this.setState({ testi : res })
        })
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevProps.update===true){
            this.componentDidMount()
        }
    }

    render() {
        const { testi } = this.state
        return (
            <div className="page-content-wrapper section-space--inner--50" id="Tenant">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="common-page-content">
                                <h2 className="common-page-title section-space--bottom--30">Happy Clients Say</h2>
        
                                <div className="testimonial-single__wrapper">
                                    {testi.map((t,i)=>(
                                        <div className="testimonial-single__item" key={i}>
                                            <div className="testimonial-slider__single-item testimonial-slider__single-item--style2">
                                                <div className="testimonial-slider__single-item__image">
                                                    <img src={t.FULL_PATH_IMAGE} className="img-fluid" alt=""/>
                                                </div>
                                                <div className="testimonial-slider__single-item__content">
                                                    <h4 className="testimonial-name" style={{marginBottom:"0px"}}> {t.NAME}</h4>
                                                    <div className="rating">
                                                        <i className="ion-ios-star"></i>
                                                        <i className="ion-ios-star"></i>
                                                        <i className="ion-ios-star"></i>
                                                        <i className="ion-ios-star"></i>
                                                        <i className="ion-ios-star"></i>
                                                        {/* <i className="ion-ios-star-outline"></i> */}
                                                    </div>
                                                    <div className="quote-icon">
                                                        <i className="ion-quote"></i>&nbsp;
                                                        <span>{t.TESTIMONIE}</span>&nbsp;
                                                        <i className="ion-quote"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(Testimonial)